import { Component } from '@angular/core';
import {UserService} from '../../../../user.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Router} from '@angular/router';

@Component({
  selector: 'app-awsop-lab2',
  templateUrl: './awsop-lab2.component.html',
  styleUrls: ['./awsop-lab2.component.css']
})

export class AwsopLab2Component {
  labState = {};
  lab2_sec_group = '';

  constructor(public ngxSmartModalService: NgxSmartModalService, private userService: UserService, private router: Router) { }


  verifyLab2() {
    if (this.lab2_sec_group.length == 0 ) {
      alert("Missing security group")
    }

    this.userService.verifyLab2(this.lab2_sec_group).subscribe(
      res => {
        let pass = res['checks']["overallPass"]
        this.labState['lab2'] = pass;
        if (pass) {
          alert('You passed!!')
        } else {
          alert("You failed lab 2. Please try again.")
        }
      },
      err => {
        console.log("Error occured", err);
      }
    );

  }

  openPopup() {
    this.ngxSmartModalService.getModal('infoModal').open()
  }
}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab2/awsop-lab2.component.ts